var _rect, _path, _circle, _circle2, _path2, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPulseai(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 520,
    fill: "#1f2937"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 300h125l35-120 70 235 55-180 42 65h323",
    fill: "none",
    stroke: "#fb7185",
    strokeWidth: 12,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 305,
    cy: 415,
    r: 45,
    fill: "#f97316",
    opacity: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 570,
    cy: 145,
    r: 75,
    fill: "#facc15",
    opacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M570 95v100M520 145h100",
    stroke: "#422006",
    strokeWidth: 12
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 75,
    fill: "#ffe4e6",
    fontFamily: "sans-serif",
    fontSize: 48,
    fontWeight: 700
  }, "PULSEAI")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 475,
    fill: "#fda4af",
    fontFamily: "monospace",
    fontSize: 22
  }, "AI ENERGY &amp; HARDWARE PROFILER")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulseai);
export default __webpack_public_path__ + "static/media/pulseai.3a6a0647cb993383f1792cf046b9a5ab.svg";
export { ForwardRef as ReactComponent };